// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"0cecaea7","425":"d0cd1a48","442":"fbb6df4f","554":"0cecaea7","688":"d0cd1a48","703":"88d41ecb","831":"3122895d","836":"d257bc1a","925":"fbb6df4f"}[chunkId] + ".chunk.css";
};